import parsePhoneNumber from "libphonenumber-js"

export function formatUsPhone(phone: any) {
  const phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/)

  phone = phone.trim()
  const results = phoneTest.exec(phone)
  if (results !== null && results.length > 8) {
    return `(${results[3]}) ${results[4]}-${results[5]}${typeof results[8] !== "undefined" ? ` x${results[8]}` : ""}`
  } else {
    return phone
  }
}

export function formatAnyPhoneNumber(countryCode: string, phone: string): string {
  if (!phone && !countryCode) {
    return ""
  }

  const parsed = parsePhoneNumber(`+${countryCode}${phone}`)
  if (!parsed) {
    return countryCode + phone
  }

  if (countryCode != "") {
    return `+${countryCode} ${parsed.formatNational()}`
  }

  return `+${parsed?.countryCallingCode} ${parsed.formatNational()}`
}

export function formatNationalPhoneNumber(countryCode: string, phone: string): string {
  if (!phone && !countryCode) {
    return ""
  }

  if (!phone) {
    return ""
  }

  const parsed = parsePhoneNumber(`+${countryCode}${phone}`)
  if (!parsed) {
    return phone
  }

  return parsed.formatNational()
}
